import * as React from 'react'

/**
 * Where the player's controls sit: on the theme surface (the page, the
 * mini-player) or on the cover's color (the hero, the embed card, the phone's
 * now-playing sheet). The tone picks the colors that keep AA contrast on each.
 */
export type PlayerTone = 'surface' | 'onColor'
export const PlayerToneContext = React.createContext<PlayerTone>('surface')
export const usePlayerTone = () => React.useContext(PlayerToneContext)
